export default __webpack_public_path__ + "static/media/term-use-bahasa.b7118fc6.png";